const basicFetch = async (endpoint) => {
    const req = await fetch(`${process.env.REACT_APP_TMDB_BASE_URL}${endpoint}&language=pt-BR&api_key=${process.env.REACT_APP_TMDB_PUBLIC_KEY}`);
    const json =  await req.json();
    //console.log(json)
    return json;
}

export default {
    getHomelist: async (category, pageNumber) =>{
        let data = {};
        switch(category){
            case 'nowplaying':
                data.slug='nowplaying';
                data.title='Em cartaz';
                data.items = await basicFetch(`/movie/now_playing?page=${pageNumber}`);
            break;
            case 'originals':
                data.slug='originals';
                data.title='Séries em alta';
                data.items = await basicFetch(`/discover/tv?with_network=213&page=${pageNumber}`);
            break;
            case 'trending':
                data.slug='trending';
                data.title='Recomendados para você';
                data.items = await basicFetch(`/trending/all/week?page=${pageNumber}`);
            break;
            case 'toprated':
                data.slug='toprated';
                data.title='Filmes em alta';
                data.items = await basicFetch(`/movie/top_rated?page=${pageNumber}`);
            break;
            case 'action':
                data.slug='action';
                data.title='Ação';
                data.items = await basicFetch(`/discover/movie?with_genres=28&page=${pageNumber}`);
            break;
            case 'adventure':
                data.slug='adventure';
                data.title='Aventura';
                data.items = await basicFetch(`/discover/movie?with_genres=12&page=${pageNumber}`);
            break;
            case 'animation':
                data.slug='animation';
                data.title='Animação';
                data.items = await basicFetch(`/discover/movie?with_genres=16&page=${pageNumber}`);
            break;
            case 'comedy':
                data.slug='comedy';
                data.title='Comédia';
                data.items = await basicFetch(`/discover/movie?with_genres=35&page=${pageNumber}`);
            break;
            case 'crime':
                data.slug='crime';
                data.title='Crime';
                data.items = await basicFetch(`/discover/movie?with_genres=80&page=${pageNumber}`);
            break;
            case 'drama':
                data.slug='drama';
                data.title='Drama';
                data.items = await basicFetch(`/discover/movie?with_genres=18&page=${pageNumber}`);
            break;
            case 'documentary':
                data.slug='documentary';
                data.title='Documentários';
                data.items = await basicFetch(`/discover/movie?with_genres=99&page=${pageNumber}`);
            break;
            case 'family':
                data.slug='family';
                data.title='Para familia';
                data.items = await basicFetch(`/discover/movie?with_genres=10751&page=${pageNumber}`);
            break;
            case 'fantasy':
                data.slug='fantasy';
                data.title='Fantasia';
                data.items = await basicFetch(`/discover/movie?with_genres=14&page=${pageNumber}`);
            break;
            case 'history':
                data.slug='history';
                data.title='História';
                data.items = await basicFetch(`/discover/movie?with_genres=36&page=${pageNumber}`);
            break;
            case 'horror':
                data.slug='horror';
                data.title='Terror';
                data.items = await basicFetch(`/discover/movie?with_genres=27&page=${pageNumber}`);
            break;
            case 'music':
                data.slug='music';
                data.title='Musical';
                data.items = await basicFetch(`/discover/movie?with_genres=10402&page=${pageNumber}`);
            break;
            case 'mystery':
                data.slug='mystery';
                data.title='Suspense';
                data.items = await basicFetch(`/discover/movie?with_genres=9648&page=${pageNumber}`);
            break;
            
            case 'romance':
                data.slug='romance';
                data.title='Romance';
                data.items = await basicFetch(`/discover/movie?with_genres=10749&page=${pageNumber}`)
            break;
            case 'fiction':
                data.slug='fiction';
                data.title='Ficção científica';
                data.items = await basicFetch(`/discover/movie?with_genres=878&page=${pageNumber}`)
            break;
           
        }
        return{
                slug: data.slug,
                title: data.title,
                items: data.items
            }
        
    },
    getAditionalInfo: async (movieId, type) =>{
        let info ={}
        if(movieId){
            switch(type){
                case 'movie':
                    info = basicFetch(`/movie/${movieId}?`);
                break;
                case 'tv':
                    info = basicFetch(`/tv/${movieId}?`);
                break;
                default:
                    info = null;
                break;
            }
        }
        return info;

    },
    getSeasonsInfo: async (movieId, type, seasonNumber) =>{
        let info ={}
        if(movieId){
            switch(type){
                case 'movie':
                    info = basicFetch(`/movie/${movieId}/season/${seasonNumber}?`);
                break;
                case 'tv':
                    info = basicFetch(`/tv/${movieId}/season/${seasonNumber}?`);
                break;
                default:
                    info = null;
                break;
            }
        }
        return info;

    },
    searchInfo: async (query,pageNumber) =>{
         
        let info = basicFetch(`/search/multi?query=${query}&page=${pageNumber}`);
        return info;
    },
}
